module.exports = __webpack_public_path__ + "img/partners-financer.ec22326f.png";